import { ComponentChildren, h } from 'preact'
import styles from './WidgetFrame.css'

type Props = {
  children: ComponentChildren
}

export function WidgetFrame(props: Props) {
  return <div class={styles.widgetFrame}>{props.children}</div>
}
